const CompanyZhCN = {
    info: {
        one: {
            title: "以科技赋能业务成长",
            content: "Blueshine 提供端到端 IT 解决方案，帮助企业克服挑战并推动成果。从策略咨询到无缝系统实施，我们与各行各业的企业合作，帮助他们转型营运并取得持久成功。",
        },
        two: {
            title: "简化企业电子商务",
            content: "Blueshine 的预先建置框架消除了设定的复杂性。借助内建的支付、库存和分析功能，您只需几天（而不是几个月）即可拥有一个安全、可扩展的店面。",
        },
        three: {
            title: "企业级技术，专为速度与安全而打造",
            content: "Blueshine 基于尖端框架提供关键任务系统，该框架将快速部署与卓越的安全性相结合。我们的集成方法涵盖身份管理、无缝用户体验、交易处理和合规性跟踪，因此您的业务从第一天起就能以最佳性能运行。",
        },
        letTalk: "让我们谈谈",
        haHelp: "我们很乐意提供帮助",
    },
    vision: {
        top: {
            title: "科技与业务转型的交会点",
            content: `<p>在当今的数位时代，保持技术领先地位是一项挑战——即使对于最先进的组织也是如此。在 Blueshine，我们致力于弥合创新与执行之间的差距。</p>
<p>我们的团队不仅了解技术，更懂得如何策略性地运用技术，推动您的业务发展。凭借卓越的服务品质和始终保持最高品质标准的良好记录，我们已成为全球企业和本地企业值得信赖的合作伙伴。</p>
<p>选择 Blueshine－深厚的技术专长与可衡量的业务成果完美结合。</p>`,
        },
        content: {
            title1: "系统整合",
            content1: "在 Blueshine，我们不仅连接系统，还将技术与您的策略目标相结合。我们的方法将深入的业务流程理解与技术专长相结合，提供能够驱动真正价值的大规模整合解决方案。",
            title2: "电子商务",
            content2: "作为电子商务策略和 SAP Hybris 实施领域的领导者，我们设计跨行动、云端和社交平台的无缝购物体验，并由智慧分析和人工智慧提供支持，以推动可衡量的成长。我们不只是实施系统；我们重塑商业生态系统，让每个数位接触点都成为创收机会，让每次互动都加深客户关系。",
            title3: "咨询服务",
            content3: "Blueshine 结合业务和 IT 专业知识，提升您组织的潜力。我们不只是咨询，我们还与您合作，从根本上转变您的流程、人才和技术生态系统。",
        }
    }
}

export default CompanyZhCN;